import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { DesignSystemToken } from 'designSystem/types';
import TokenPreview from './TokenPreview';
import { formatTokenValue } from './tokenUtil';
import * as S from './styles';

interface TokenCardProps {
	token: DesignSystemToken;
	onClick?: () => void;
}

export const TokenCard = ({ token, onClick }: TokenCardProps) => {
	const selected = useSelector(
		(r: RootReducer) =>
			r.mode.selectedDsPicks.some((p) => p.kind === 'token' && p.cssVariable === token.cssVariable)
	);
	return (
		<S.TokenCard $selected={selected} onClick={onClick}>
			<S.TokenTooltip>{formatTokenValue(token.value)}</S.TokenTooltip>
			<TokenPreview token={token} />
			<S.TokenName>{token.name}</S.TokenName>
			<S.TokenCssVariable>{token.cssVariable}</S.TokenCssVariable>
		</S.TokenCard>
	);
};
